module.exports = __webpack_public_path__ + "img/XZC-alt.99b56912.svg";